import React from 'react';
import {
  Description,
  HeaderWrapper,
  IconContainerStyled,
  MainTitle,
  Title,
} from './SectionHeaderCms.style';
import { hexToRgb, rgbDataURL } from 'corporate-utils';
import { getStrapiMedia } from '../../utils/media';
import ImageWithFallback from '../image-with-fallback/ImageWithFallback';
import { getPersonalizationAllAttributes } from '../../utils/style';
import { DEFAULT_IMAGE } from '../../models/domain/const';
import { SectionHeader } from '../../models/auto-generated-strapi-types/types/components/SectionHeader';
import Markdown from 'markdown-to-jsx';
import { PrerenderRequest } from 'corporate-types';

const SectionHeaderCms: React.FC<SectionHeader & PrerenderRequest> = ({
  description,
  personalization,
  mainTitle,
  title,
  topIcon,
  isPrerenderRequest,
}) => {
  return (
    <HeaderWrapper
      personalization={getPersonalizationAllAttributes(
        personalization || [],
        'headerWrapper'
      )}
    >
      {topIcon &&
        topIcon?.data?.attributes &&
        topIcon?.data?.attributes?.url && (
        <IconContainerStyled>
          <ImageWithFallback
            layout={'fill'}
            objectFit="contain"
            placeholder="blur"
            blurDataURL={rgbDataURL(
              hexToRgb('ffffff')?.[0],
              hexToRgb('ffffff')?.[1],
              hexToRgb('ffffff')?.[2]
            )}
            src={getStrapiMedia(topIcon?.data?.attributes?.url ?? '')}
            alt={''}
            fallbackSrc={DEFAULT_IMAGE}
            isPrerenderRequest={isPrerenderRequest}
          />
        </IconContainerStyled>
      )}
      {/* First title */}
      {mainTitle && (
        <MainTitle
          personalization={getPersonalizationAllAttributes(
            personalization || [],
            'mainTitle'
          )}
        >
          <Markdown>{mainTitle}</Markdown>
        </MainTitle>
      )}
      {/* Second title */}
      {title && (
        <Title
          personalization={getPersonalizationAllAttributes(
            personalization || [],
            'title'
          )}
        >
          <Markdown>{title}</Markdown>
        </Title>
      )}
      {description ? (
        <Description
          personalization={getPersonalizationAllAttributes(
            personalization || [],
            'description'
          )}
        >
          <Markdown>{description}</Markdown>
        </Description>
      ) : (
        <></>
      )}
    </HeaderWrapper>
  );
};

export default SectionHeaderCms;
